module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAMCAYAAAHZkpeGAAAAAXNSR0IArs4c6QAAALhJREFUGBljmDlz5kQGBAByy8C8WbNm/UQIw1lA+QA4B1kNI0wUqMKNkZHRlgEoGw3kZMIkQAK5MA4TkPEEKFsIEgDrnTNnju/fv381YSoYgLLfwBy4NUCR3zBpxtmzZwf9+/dvBdCu0rS0NGRPQAwEqQQq8v////8qIK5KT0/vBYnBXQrigADQWG8gtRaIG1hAAjAAkwBa0QK0ogMsCXRNGNC4JVB7OWCKWYCqZwMFTwBVssEEYTQAgUpNGTSkyoAAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./static/img/next.png
// module id = 6D7q
// module chunks = 256